import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import Edit from '../assets/icons/feather/Edit.svg?react';

export function EditIcon(props: SvgIconProps) {
  return <SvgIcon component={Edit} inheritViewBox {...props} />;
}
